module.exports = "//static.hsappstatic.net/SalesContentIndexUI/static-3.8187/images/empty-folder.svg"